import { render, staticRenderFns } from "./detailDiscountLog.vue?vue&type=template&id=5a910893&"
import script from "./detailDiscountLog.vue?vue&type=script&lang=js&"
export * from "./detailDiscountLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports